import React from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";
import { useGetClasses } from "../../../hooks/classHooks/class.hooks";
import { getValue } from "../../../utils/object.utils";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

/**
 * Example graphData:
 * {
 *   Thecho: {
 *     "U.K.G": 100,
 *     "L.K.G": 90,
 *     Nursery: 80
 *   },
 *   "Prayagpokhari": {
 *     "U.K.G": 75,
 *     "L.K.G": 60,
 *     Nursery: 85
 *   }
 * }
 */
interface IStudentCountGraphData {
  label: string[];

  graphData: {
    [key: string]: {
      [key: string]: number;
    };
  };
}
interface Props {
  studentCountGraphData: IStudentCountGraphData;
}

export const StudentsGradeGraph = ({ studentCountGraphData }: Props) => {
  const { isLoading: isClassesLoading } = useGetClasses();

  if (isClassesLoading) return <div />;

  const labels = getValue(studentCountGraphData, "labels", []);

  const graphData = getValue(studentCountGraphData, "graphData", []);

  const barColors = ["rgba(186, 38, 5, 0.8)", "rgba(255, 160, 122, 0.8)"];

  const dataset = Object.entries(graphData).map(([key, value], index) => {
    return {
      label: key,
      data: labels.map((label: string) => {
        return getValue(value, label, 0);
      }),
      backgroundColor: barColors[index],
      stack: key,
    };
  });

  const data = {
    labels,
    datasets: dataset,
  };

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: "top" as const,
      },
      title: {
        display: true,
        text: "Distribution of Students by Branch and Grade",
      },
    },
  };
  return (
    <div>
      <Bar data={data} options={options} />
    </div>
  );
};
